<template>
  <div>
    <UserAccount></UserAccount>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const UserAccount = defineAsyncComponent(() =>
  import("@/components/addUser/UserAccount")
);
export default {
  components: {
    UserAccount,
  },
};
</script>
